import { BaseDynamicZoneModel } from "@models/dynamic-zones";

export enum LastScrollCTAVariants {
  BASE = "base",
  BANNER = "banner",
}
export interface LastScrollCTADynamicZoneModel extends BaseDynamicZoneModel {
  innerHtml: string;
  ctaText: string;
  ctaLink: string;
  variant: LastScrollCTAVariants;
}
